import React from 'react';

import { useQuery } from '@tanstack/react-query';

import ContactForm from './ContactForm';

import ContactService from '../../../../../../services/ContactService';

export default function Contacts({ id }) {
  const { data: contacts, refetch: refetchContacts } = useQuery({
    queryKey: ['contacts', id],
    queryFn: () => ContactService.getContacts(id),
    enabled: !!id,
  });

  return (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <ContactForm
        title="Borrower Support"
        type="borrower_support"
        servicerId={id}
        groupSizeOffset={8}
        contact={contacts?.find(
          (contact) => contact.type === 'borrower_support'
        )}
        refetch={refetchContacts}
      />
      <ContactForm
        title="Lender Support"
        type="lender_support"
        servicerId={id}
        groupSizeOffset={16}
        contact={contacts?.find((contact) => contact.type === 'lender_support')}
        refetch={refetchContacts}
      />
      <ContactForm
        title="Title Support"
        type="title_support"
        servicerId={id}
        groupSizeOffset={24}
        contact={contacts?.find((contact) => contact.type === 'title_support')}
        refetch={refetchContacts}
      />
    </div>
  );
}
